import styles from "./FinancialTab.module.scss";
import classNames from "classnames/bind";
import BaseTableV2 from "~/components/common/base-table-v2/BaseTableV2";
import { useRef, useState } from "react";
import { MenuVerticalIcon, PlusIcon, SearchIcon } from "~/assets/icons";
const cx = classNames.bind(styles);

const budgetHeadCells = [
  { id: "budget", label: "Budget", width: "23%" },
  { id: "budgetDate", label: "Budget Date", width: "23%" },
  { id: "grossProfit", label: "Gross Profit", width: "23%" },
  { id: "netProfit", label: "Net Profit", width: "23%" },
  { id: "actions", label: "Actions", width: "8%" },
];

const invoiceHeadCells = [
  { id: "invoiceId", label: "Invoice ID", width: "8%" },
  { id: "requestPayment", label: "Request Payment", width: "15%" },
  { id: "related", label: "Related", width: "8%" },
  { id: "invoiceDate", label: "Invoice Date", width: "8%" },
  { id: "internalNote", label: "Internal Note", width: "18%" },
  { id: "total", label: "Total", width: "8%" },
  { id: "paid", label: "Paid", width: "8%" },
  { id: "due", label: "Due", width: "8%" },
  { id: "status", label: "Status", width: "7%" },
  { id: "actions", label: "Actions", width: "7%" },
];

const creditMemoHeadCells = [
  { id: "number", label: "Number", width: "15.5%" },
  { id: "requestRecord", label: "Request Record", width: "15.5%" },
  { id: "status", label: "Status", width: "15.5%" },
  { id: "total", label: "Total", width: "15.5%" },
  { id: "memoDate", label: "Memo Date", width: "15.5%" },
  { id: "dateUpdated", label: "Date Updated", width: "15.5%" },
  { id: "actions", label: "Actions", width: "7%" },
];

const paymentHeadCells = [
  { id: "date", label: "Date", width: "9%" },
  { id: "reference", label: "Reference", width: "9%" },
  { id: "total", label: "Total", width: "9%" },
  { id: "invoices", label: "Invoices", width: "9%" },
  { id: "method", label: "Method", width: "9%" },
  { id: "relatedRecords", label: "Related Records", width: "9%" },
  { id: "createdBy", label: "Created By", width: "11%" },
  { id: "dateUpdated", label: "Date Updated", width: "9%" },
  { id: "status", label: "Status", width: "9%" },
  { id: "actions", label: "Actions", width: "7%" },
];

const BudgetMockData = [
  {
    id: "1",
    budget: "B-125",
    budgetDate: "5/5/2025",
    grossProfit: "$00,000",
    netProfit: "$00,000",
  },
];

const InvoiceMockData = [
  {
    id: "1",
    invoiceId: "IN-125",
    requestPayment: "Send Reminder",
    related: "B-125",
    invoiceDate: "5/5/2025",
    internalNote: "Please process this invoice.",
    total: "$00,000",
    paid: "$00,000",
    due: "$00,000",
    status: "Due",
  },
];

const CreditMemosMockData = [
  {
    id: "1",
    number: "CM-125",
    requestRecord: "Send Reminder",
    status: "Due",
    total: "$00,000",
    memoDate: "5/5/2025",
    dateUpdated: "5/5/2025",
  },
];

const PaymentMockData = [
  {
    id: "1",
    date: "5/5/2025",
    reference: "PM-125",
    total: "$00,000",
    invoices: "IN-125",
    method: "Credit Card",
    relatedRecords: "B-125",
    createdBy: "John Doe",
    dateUpdated: "5/5/2025",
    status: "Completed",
  },
];

const FinancialTab = () => {
  const [textSearchBudget, setTextSearchBudget] = useState("");
  const [textSearchInvoice, setTextSearchInvoice] = useState("");
  const [textSearchCreditMemo, setTextSearchCreditMemo] = useState("");
  const [textSearchPayment, setTextSearchPayment] = useState("");
  const searchTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleSearchBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setTextSearchBudget(value);
    }, 1000);
  };

  const handleSearchInvoiceChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setTextSearchInvoice(value);
    }, 1000);
  };

  const handleSearchCreditMemoChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setTextSearchCreditMemo(value);
    }, 1000);
  };

  const handleSearchPaymentChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setTextSearchPayment(value);
    }, 1000);
  };

  return (
    <div className={cx("financial-tab-container")}>
      {/* Budgets */}
      <div className={cx("section")}>
        <div className={cx("header")}>
          <h3 className={cx("header-title")}>Budgets</h3>
          <div className={cx("header-actions")}>
            <div className={cx("search")}>
              <SearchIcon className={cx("search-icon")} />
              <input
                type="text"
                placeholder="Search budget"
                className={cx("search-input")}
                onChange={handleSearchBudgetChange}
              />
            </div>

            <button className={cx("add-button")} onClick={() => {}}>
              <PlusIcon className={cx("add-icon")} />
              <p className={cx("add-text")}>Add</p>
            </button>
          </div>
        </div>

        <div>
          <BaseTableV2
            data={BudgetMockData}
            headCells={budgetHeadCells}
            page={1}
            totalPages={1}
            totalItems={1}
            showPagination
            renderCell={(budget: any, index: number) => (
              <>
                <td className={cx("table-body-cell", "w-[23%]")}>
                  <p className={cx("text-content")}>{budget.budget}</p>
                </td>
                <td className={cx("table-body-cell", "w-[23%]")}>
                  <p className={cx("text-content")}>{budget.budgetDate}</p>
                </td>
                <td className={cx("table-body-cell", "w-[23%]")}>
                  <p className={cx("text-content")}>{budget.grossProfit}</p>
                </td>
                <td className={cx("table-body-cell", "w-[23%]")}>
                  <p className={cx("text-content")}>{budget.netProfit}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <button className={cx("action-button")}>
                    <MenuVerticalIcon className={cx("action-icon")} />
                  </button>
                </td>
              </>
            )}
          />
        </div>
      </div>

      {/* Invoices */}
      <div className={cx("section")}>
        <div className={cx("header")}>
          <h3 className={cx("header-title")}>Invoices</h3>
          <div className={cx("header-actions")}>
            <div className={cx("search")}>
              <SearchIcon className={cx("search-icon")} />
              <input
                type="text"
                placeholder="Search invoice"
                className={cx("search-input")}
                onChange={handleSearchInvoiceChange}
              />
            </div>

            <button className={cx("add-button")} onClick={() => {}}>
              <PlusIcon className={cx("add-icon")} />
              <p className={cx("add-text")}>Add</p>
            </button>
          </div>
        </div>

        <div>
          <BaseTableV2
            data={InvoiceMockData}
            headCells={invoiceHeadCells}
            page={1}
            totalPages={1}
            totalItems={1}
            showPagination
            renderCell={(invoice: any, index: number) => (
              <>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.invoiceId}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15%]")}>
                  <p className={cx("text-content")}>{invoice.invoiceDate}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.related}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.invoiceDate}</p>
                </td>
                <td className={cx("table-body-cell", "w-[18%]")}>
                  <p className={cx("text-content")}>{invoice.internalNote}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.total}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.paid}</p>
                </td>
                <td className={cx("table-body-cell", "w-[8%]")}>
                  <p className={cx("text-content")}>{invoice.due}</p>
                </td>
                <td className={cx("table-body-cell", "w-[7%]")}>
                  <p className={cx("text-content")}>{invoice.status}</p>
                </td>
                <td className={cx("table-body-cell", "w-[7%]")}>
                  <button className={cx("action-button")}>
                    <MenuVerticalIcon className={cx("action-icon")} />
                  </button>
                </td>
              </>
            )}
          />
        </div>
      </div>

      {/* Credit Memos */}
      <div className={cx("section")}>
        <div className={cx("header")}>
          <h3 className={cx("header-title")}>Credit Memos</h3>
          <div className={cx("header-actions")}>
            <div className={cx("search")}>
              <SearchIcon className={cx("search-icon")} />
              <input
                type="text"
                placeholder="Search credit memos"
                className={cx("search-input")}
                onChange={handleSearchCreditMemoChange}
              />
            </div>

            <button className={cx("add-button")} onClick={() => {}}>
              <PlusIcon className={cx("add-icon")} />
              <p className={cx("add-text")}>Add</p>
            </button>
          </div>
        </div>

        <div>
          <BaseTableV2
            data={CreditMemosMockData}
            headCells={creditMemoHeadCells}
            page={1}
            totalPages={1}
            totalItems={1}
            showPagination
            renderCell={(creditMemo: any, index: number) => (
              <>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>{creditMemo.number}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>
                    {creditMemo.requestRecord}
                  </p>
                </td>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>{creditMemo.status}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>{creditMemo.total}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>{creditMemo.memoDate}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15.5%]")}>
                  <p className={cx("text-content")}>{creditMemo.dateUpdated}</p>
                </td>
                <td className={cx("table-body-cell", "w-[7%]")}>
                  <button className={cx("action-button")}>
                    <MenuVerticalIcon className={cx("action-icon")} />
                  </button>
                </td>
              </>
            )}
          />
        </div>
      </div>

      {/* Payment */}
      <div className={cx("section")}>
        <div className={cx("header")}>
          <h3 className={cx("header-title")}>Payments</h3>
          <div className={cx("header-actions")}>
            <div className={cx("search")}>
              <SearchIcon className={cx("search-icon")} />
              <input
                type="text"
                placeholder="Search payments"
                className={cx("search-input")}
                onChange={handleSearchPaymentChange}
              />
            </div>

            <button className={cx("add-button")} onClick={() => {}}>
              <PlusIcon className={cx("add-icon")} />
              <p className={cx("add-text")}>Add</p>
            </button>
          </div>
        </div>

        <div>
          <BaseTableV2
            data={PaymentMockData}
            headCells={paymentHeadCells}
            page={1}
            totalPages={1}
            totalItems={1}
            showPagination
            renderCell={(payment: any, index: number) => (
              <>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.date}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.reference}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.total}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.invoices}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.method}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.relatedRecords}</p>
                </td>
                <td className={cx("table-body-cell", "w-[11%]")}>
                  <p className={cx("text-content")}>{payment.createdBy}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.dateUpdated}</p>
                </td>
                <td className={cx("table-body-cell", "w-[9%]")}>
                  <p className={cx("text-content")}>{payment.status}</p>
                </td>
                <td className={cx("table-body-cell", "w-[7%]")}>
                  <button className={cx("action-button")}>
                    <MenuVerticalIcon className={cx("action-icon")} />
                  </button>
                </td>
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default FinancialTab;
